import classNames from 'classnames';
import dateFns from 'date-fns';
import React from 'react';
import { Container } from 'reactstrap';
import { applicationTitle } from '../../../constants';
import './footer.css';

const Footer = ({ fixed }) => (
  <footer className={classNames('footer', { fixed })}>
    <Container>
      <span>&copy; {applicationTitle} - {dateFns.getYear(new Date())}</span>
    </Container>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/partials/footer/footer.js